<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Form',
  methods: {
    clear () {
      this.$children.forEach(e => {
        this.changeStateError(e, null, 'restart')
      })
    },
    validate (rules) {
      let result = 0
      rules.forEach(rule => {
        this.$children.forEach(e => {
          if (e.prop === rule.prop) {
            switch (rule.type) {
              case 'empty':
                if (!this.emptyValidate(e)) {
                  this.changeStateError(e, rule, 'error')
                  result++
                } else this.changeStateError(e, rule, 'success')
                break
              case 'email':
                if (!this.emailValidate(e)) {
                  this.changeStateError(e, rule, 'error')
                  result++
                } else this.changeStateError(e, rule, 'success')
                break
              case 'equal':
                if (!this.equalValidate(e, rule)) {
                  this.changeStateError(e, rule, 'error')
                  result++
                } else this.changeStateError(e, rule, 'success')
                break
            }
          }
        })
      })
      return result === 0
    },
    changeStateError (element, rule, operation) {
      // Se agrega una actualizacion al formulario
      switch (operation) {
        case 'success':
          element.validation = true
          element.isValid = true
          if (rule.messageOk) element.validationMessage = rule.messageOk
          else element.validationMessage = ''
          break
        case 'error':
          element.validation = true
          element.isValid = false
          element.validationMessage = rule.message
          break
        case 'restart':
          element.validation = false
          break
      }
    },
    emptyValidate (element) {
      return /\S/.test(element.value)
    },
    emailValidate (element) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(element.value).toLowerCase())
    },
    equalValidate (element, rule) {
      let returnvalue = false
      // recorremos buscando el elemento a validar en la igualdad
      this.$children.forEach(ch => {
        if (ch.prop === rule.equal) {
          returnvalue = ch.value === element.value
        }
      })
      return returnvalue
    }
  }
}
</script>
